<div>
  <h3 class="font-bold text-lg text-cp-primary-100 mb-3">Über den Versicherer</h3>
  @if (logo$() | async; as logo) {
    <img
      [src]="'data:image/svg+xml;base64,' + logo"
      [alt]="versichererName() + ' logo'"
      class="h-12 max-w-[160px] w-auto mb-4 object-contain object-left"
    />
  }
</div>
